module.exports = __webpack_public_path__ + "img/te-mision4.9b6e38b8.jpg";